import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PermissionHelper } from "../../helpers/permissions.helper";
import { APP_INTEGRATION } from "../../imports/app.integration";
import { ViewType } from "../../models/enums/viewtype.enum";
import { LayoutService } from "../../services/layout.service";
import { MediaService } from "../../services/media.service";
import { NavigationService } from "../../services/navigation.service";
import { UsersService } from "../../services/users.service";


@Component({
    selector: 'integration-page',
    templateUrl: './integration.page.html',
    styleUrls: ['./integration.page.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntegrationPage implements OnInit, OnDestroy {
    URL: string;
    UserName: string;
    MenuItems = [];
    Logo: string;
    Subscriptions: Subscription[] = [];

    constructor(private cdRef: ChangeDetectorRef, private router: Router) {
    }

    ngOnInit(): void {
        this.Subscriptions.push(NavigationService.NavigationStart.subscribe(x => {
            this.MenuItems.forEach(y => y.Selected = y.URL == x);
        }));
        this.Subscriptions.push(MediaService.ExternalImageURL.subscribe(x => {
            this.Logo = x + 'BeSync_Logo.svg';
        }));
        // Set the selected page in the navigation service
        NavigationService.SelectedPage.next('integration');
        // Change the view type in the layout service
        LayoutService.ViewType.next(ViewType.Edit);
        LayoutService.ViewType.next(ViewType.View);
        // Set edit permission to false
        PermissionHelper.EditPermission.next(false);
        // Subscribe to the active user from the UsersService
        this.Subscriptions.push(UsersService.ActiveUser.subscribe(x => {
            let actURL: string;
            let actName = '';
            // If an active user exists, set the user name and profile picture URL
            if (x) {
                actName = x.DisplayName;
                if (x.Image) {
                    const url = MediaService.ProfilePicURL.getValue();
                    if (url) {
                        actURL = url + x.SID + '/' + x.Image;
                    }
                }
            }
            // Update component properties and trigger change detection
            this.URL = actURL;
            this.UserName = actName;
            this.cdRef.detectChanges();
        }));
        const url = this.router.url;
        // Initialize menu list
        const menuList = [];
        // Iterate over APP_INTEGRATION to build the menu list
        APP_INTEGRATION.forEach(entry => {
            if (typeof entry['GetMenuEntry'] === 'function') {
                const setting = entry['GetMenuEntry']();
                if (setting) {
                    setting.Selected = setting.URL == url;
                    menuList.push(setting);
                }
            }
        });
        // Sort and set the MenuItems property
        this.MenuItems = menuList.sort((a, b) => a.Index - b.Index);
        // Trigger change detection
        this.cdRef.detectChanges();
    }

    ngOnDestroy(): void {
        this.Subscriptions.forEach(x => {
            x.unsubscribe();
        });
        this.Subscriptions = null;
    }
}
